import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import { filter } from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import { Get } from "../../constant/thunk";
import { Tooltip } from "..";
import RouteAllowed from "../../helper/isRouteAllowed";
import {
  Resources,
  updateNotificationCountFromWebSocket
} from "../../features/notifications/redux/notificationRedux";
import DesktopBreakpoint from "../../context/desktop_breakpoint";
import PhoneBreakpoint from "../../context/phone_breakpoint";

class DeviceMetricsNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      mpsModal: false,
      isLoading: true,
      refetch: true,
      perPage: 10
    };
  }

  getAllNotification = () => {
    const { getNotifications } = Resources;
    getNotifications.url = `/notifications?page=${1}&per_page=${10}`;
    this.props.Get(getNotifications).then(() => {
      this.setState({ isLoading: false });
    });
  };

  markAllNotificationCountAsRead = () => {
    const { resetNotificationCount } = Resources;
    this.props
      .Post(resetNotificationCount)
      .then(() =>
        this.props.updateNotificationCountFromWebSocket({ count: 0 })
      );
  };

  markNotificationAsRead = id => {
    const { notificationMarkAsRead } = Resources;
    notificationMarkAsRead.url = `/notifications/${id}/read`;
    this.props
      .Post(notificationMarkAsRead)
      .then(() => this.getAllNotification());
  };

  markAllNotificationAsRead = () => {
    const { notificationMarkAllAsRead } = Resources;
    this.props
      .Post(notificationMarkAllAsRead)
      .then(() => this.getAllNotification());
  };

  handleNext = async () => {
    const { getNotifications } = Resources;
    if (this.state.refetch) {
      this.setState(
        prevState => ({
          perPage: prevState.perPage + 10
        }),
        () => {
          getNotifications.url = `/notifications?page=${1}&per_page=${
            this.state.perPage
          }`;
          this.props.Get(getNotifications).then(response => {
            if (response.data.meta.totalPages <= response.data.meta.page) {
              this.setState({ refetch: false });
            }
          });
        }
      );
    }
    return true;
  };

  toggle = () => {
    if (!this.state.dropdownOpen) {
      this.getAllNotification();
      this.markAllNotificationCountAsRead();
    }
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
    if (this.state.mpsModal) {
      this.setState({ mpsModal: false });
    }
  };

  onMouseEnter = () => {
    this.setState({ dropdownOpen: true, mpsModal: false });
  };

  onMouseLeave = () => {
    this.setState({ dropdownOpen: false, mpsModal: false });
  };

  noNotification = () => (
    <DropdownItem className="ticket-notification--message">
      <div className="ticket-notification-item">
        <i className="fas fa-bell fa-4x" />
        <span style={{ fontWeight: "bold", fontSize: "20", color: "grey" }}>
          No notifications right now!
        </span>
      </div>
    </DropdownItem>
  );

  handleIcon = type => {
    if (type.search("CPU") > -1) {
      return <i className="mr-2 fas fa-microchip"></i>;
    }
    if (type.search("Memory") > -1) {
      return <i className="mr-2 fas fa-memory" />;
    }
    if (type.search("Disk") > -1) {
      return <i className="mr-2 fas fa-compact-disc"></i>;
    }
    if (type === "Temperature") {
      return <i className="mr-2 fas fa-thermometer-half" />;
    }
  };

  render() {
    const { roles, permission } = this.props;
    const { isLoading } = this.state;
    return (
      <Dropdown
        className="d-inline-block"
        isOpen={this.state.dropdownOpen}
        toggle={this.toggle}
      >
        <RouteAllowed
          roles={roles && roles}
          permission={permission.metrics.show}
        >
          <DropdownToggle caret className="header-dropdown">
            <div className="">
              <i
                className="fas fa-bell bellIcon"
                onKeyPress={() => {}}
                role="button"
                tabIndex="0"
              >
                {this.props.ticketCount !== 0 && (
                  <sup>
                    {" "}
                    <Badge
                      style={{
                        background: "#dd4a44",
                        color: "white",
                        padding: "3px",
                        position: "absolute",
                        zIndex: "9"
                      }}
                    >
                      {this.props.ticketCount}
                    </Badge>
                  </sup>
                )}
              </i>
            </div>
          </DropdownToggle>
        </RouteAllowed>

        <DropdownMenu
          className="ticket-notification"
          onClick={() => this.setState({ dropdownOpen: true, mpsModal: true })}
        >
          <DropdownItem className="ticket-notification-header d-flex justify-content-between">
            <span
              style={{
                textDecoration: "none",
                color: "#382e29",
                fontWeight: "600"
              }}
            >
              Device Metrics Notifications
            </span>
            <span
              className="ticket-notification_mark-all-as-read"
              onClick={this.markAllNotificationAsRead}
            >
              Mark all as read
            </span>
          </DropdownItem>

          <InfiniteScroll
            dataLength={this.props.ticketList.length} // This is important field to render the next data
            next={this.handleNext}
            hasMore={this.state.refetch}
            height={500}
            style={{ overFlow: "visible" }}
          >
            {this.props.ticketList.length > 0 ? (
              this.props.ticketList.map(item => {
                return (
                  <DropdownItem
                    key={item.id}
                    className="ticket-notification--list"
                    style={{
                      background: !item.attributes.read && "rgb(234, 248, 241)"
                    }}
                    onClick={() => {
                      this.markNotificationAsRead(item.id);
                    }}
                  >
                    <Link
                      to={{
                        key: item.id,
                        pathname: `/networks/device/${item.attributes.device_id}?id=${item.attributes.device_group_id}&gn=${item.attributes.device_group_name}&n=${item.attributes.device_name}&view=groups`,
                        state: {
                          deviceID: item.attributes.device_id,
                          groupID: item.attributes.device_group_id,
                          groupName: item.attributes.device_group_name,
                          name: item.attributes.device_name || "",
                          fromNotification: true
                        }
                      }}
                    >
                      <div className="booking_request_info">
                        <div className="mr-auto">
                          {" "}
                          <strong>{item.attributes.hostname} </strong> has
                          exceeded{" "}
                          <strong> {item.attributes.alert_type} </strong>{" "}
                          threshold.{" "}
                          {/* <strong> {item.attributes.value}% </strong> */}
                        </div>
                        <DesktopBreakpoint>
                          <div className="notificationTime">
                            {moment.utc(item.attributes.created_at).fromNow()}
                          </div>
                        </DesktopBreakpoint>
                      </div>
                      <div className="mt-2 mb-2">
                        {this.handleIcon(item.attributes.alert_type)}
                        {item.attributes.value}%
                        <i className="mr-2 ml-3 fas fa-desktop" />
                        {item.attributes.mac_address}
                      </div>
                      <PhoneBreakpoint>
                        <div className="notificationTime">
                          {moment.utc(item.attributes.created_at).fromNow()}
                        </div>
                      </PhoneBreakpoint>
                    </Link>
                  </DropdownItem>
                );
              })
            ) : (
              <DropdownItem className="ticket-notification--message">
                {isLoading ? (
                  <div className="ticket-notification--message">Loading...</div>
                ) : (
                  <div className="ticket-notification-item">
                    <i className="fas fa-bell fa-4x" />
                    <span
                      style={{
                        fontWeight: "bold",
                        fontSize: "20",
                        color: "grey"
                      }}
                    >
                      No notifications right now!
                    </span>
                  </div>
                )}
              </DropdownItem>
            )}
            {/* {this.handleItems()} */}
          </InfiniteScroll>
          <DropdownItem className="ticket-notification--footer">
            <Link to="/notifications" style={{ textDecoration: "none" }}>
              <span role="button">See All</span>
            </Link>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }
}
function mapStateToProps(state) {
  const { list } = state.notificationList;
  const count =
    state.notificationList.meta &&
    state.notificationList.meta.notification.count;
  return {
    ticketList: list || [],
    ticketCount: count
  };
}

export default connect(
  mapStateToProps,
  { Get, updateNotificationCountFromWebSocket }
)(DeviceMetricsNotification);
